"use client";

import { InputHTMLAttributes } from "react";
import { FiSearch } from "react-icons/fi";
import clsx from "clsx";

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  width?: string | number;
}

export const SearchInput = ({
  className,
  width = 400,
  ...props
}: SearchInputProps) => {
  return (
    <div
      className={clsx(
        "flex items-center rounded-[10px] border",
        "border-[#D9D9D9] h-[46px] pr-3",
        className
      )}
      style={{ width }}
    >
      <FiSearch
        size={20}
        className="text-brand-500 ml-[10px] mr-[8px] shrink-0"
      />
      <input
        type="text"
        placeholder="Search"
        className="flex-1 bg-transparent outline-none text-sm text-[#8A8A8A] placeholder-[#8A8A8A]"
        {...props}
      />
    </div>
  );
};
